import { createBrowserRouter } from 'react-router';
import { appRoutes } from '@/routes/appRoutes';

export const router = createBrowserRouter(appRoutes);